import React from 'react'
import './Call.css'

const Call = () => {

  return (
    <section className='Call'>
      <div className='container'>
        <div className='row justify-content-center'>
          <div className='col-11'>
            <div className='Call-action'>
              <div className="Call-wrapper">
                <h2>Let’s discuss your project!</h2>
                <p>Leave your email and we’ll contact you to assign a call</p>
                <button>Assign a call</button>
              </div>
              <div className="Call-phone">
                <img src="/images/call/call-phone.png" alt="Phone"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Call